import React from 'react';
import DisplayNumber from './number/DisplayNumber';

const DisplayCurrency = ({ label, initialValue, handleSave: syncChanges }) => {
    return (
        <div className='field-input-group crm-editable-field-wrapper'>
            <div className='field-label'>{label}</div>
            <DisplayNumber value={initialValue} isCurrency={true} />
        </div>
    );
};

export default DisplayCurrency;
